module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/arrow-down-red.a41ba434.svg";